import dayjs from 'dayjs'
import numeral from 'numeral'

global.numeral = numeral
global.dayjs = dayjs
